import { useEffect, useState } from "react";

// Status stays available until dismissed, replaced, or the page is left.
export default function Toast({ toast }) {
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => setDismissed(false), [toast?.id]);
  const shown = toast && !dismissed;
  return (
    <div role="status" aria-live="polite" aria-atomic="true"
      className={shown ? "fixed bottom-6 left-1/2 -translate-x-1/2 z-50 max-w-[calc(100vw-2rem)]" : "sr-only"}>
      {shown && <div className="bg-green-action text-white text-sm font-display font-bold px-4 py-2.5 rounded-lg shadow-lg flex items-center gap-3">
        <span>{toast.text}</span>
        <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="min-w-6 min-h-6 rounded border border-white/70">×</button>
      </div>}
    </div>
  );
}
